import { IconButton as MaterialIconButton } from "@mui/material";
import { IconButtonProps } from "@mui/material/IconButton";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

interface IIconButtonProps extends IconButtonProps {
  id?: string;
  tooltipProps?: Partial<TooltipProps>;
}

/**
 * Icon Button Wrapper component (allows us to add addition UI elements to the Material UI IconButton)
 * Addition props contains the optional id
 * as well as the tooltip used to improve UI assistance.
 * I'll eventually add redux support for turning tooltip on or off based on preferences. - CC
 * @param props -
 */
export const IconButton = (props: IIconButtonProps): JSX.Element => {
  const { id, tooltipProps, ...iconButtonProps } = props;
  if (tooltipProps) {
    return (
      <Tooltip enterDelay={500} placement="top" {...(tooltipProps as TooltipProps)}>
        <div>
          <MaterialIconButton {...iconButtonProps}>{props.children}</MaterialIconButton>
        </div>
      </Tooltip>
    );
  } else {
    return <MaterialIconButton {...iconButtonProps}>{props.children}</MaterialIconButton>;
  }
};
